import { Home } from 'lucide-react';

export default function PhotoLimit({ onReset }) {
  return (
    <div className="px-6 py-8 text-center animate-fade-in" data-testid="photo-limit-screen">
      <div
        className="mx-auto mb-6 w-20 h-20 rounded-full flex items-center justify-center"
        style={{
          background: 'rgba(181,152,90,0.12)',
          border: '2px solid rgba(181,152,90,0.5)',
        }}
      >
        <span className="text-2xl" style={{ color: '#B5985A' }}>!</span>
      </div>

      <h3 className="font-headline text-lg mb-3 text-white">
        Limite atingido
      </h3>

      <p className="font-body text-sm mb-8" style={{ color: '#A3A3A3' }}>
        Atingiu o limite de geração de fotos. Tente novamente na sua próxima
        visita ao Karting Internacional de Palmela.
      </p>

      <button
        onClick={onReset}
        className="btn-gold w-full"
        data-testid="photo-limit-back-btn"
      >
        <Home size={18} strokeWidth={1.5} />
        Voltar ao início
      </button>
    </div>
  );
}
